module.exports = __webpack_public_path__ + "img/4.a7e58960.jpg";